/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableMobject
 */
export interface AvailableMobject {
    /**
     * 
     * @type {number}
     * @memberof AvailableMobject
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof AvailableMobject
     */
    av: boolean;
}

export function AvailableMobjectFromJSON(json: any): AvailableMobject {
    return AvailableMobjectFromJSONTyped(json, false);
}

export function AvailableMobjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableMobject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'av': json['av'],
    };
}

export function AvailableMobjectToJSON(value?: AvailableMobject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'av': value.av,
    };
}


